import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ReferenceRate } from 'src/features/referenceRates/utils/types';

const RESOURCE = '/subscriptions/reference-rate/:id/';

type QueryFnType = typeof queryFn;

interface DTO {
    id: string;
}
const queryFn = ({ id }: DTO): Promise<ReferenceRate> => {
    return axios.get(formatResourcePath(RESOURCE, { id }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetReferenceRate, RESOURCE as REFERENCE_RATE_RESOURCE };
